/**
 * "What's New" release notes — single source of truth.
 *
 * To announce a new release:
 *   1. Bump `version` (any string; users see a notice once per unique value).
 *   2. Set `date` (ISO YYYY-MM-DD; surfaces under the title).
 *   3. Replace `items` with the highlights of the release.
 *
 * The WhatsNewDialog component diffs `version` against a per-user value in
 * localStorage to decide whether to auto-open. No backend changes needed.
 *
 * `version` is ALSO consumed by the shared `<Footer />` component so bumping
 * it here rev's the version badge everywhere in the app.
 */
export const WHATS_NEW = {
  version: "1.5",
  date: "2026-07-11",
  title: "What's New in v1.5",
  items: [
    "🔧 Introducing Maintenance — a full service-schedule module tuned to your drivetrain (EV, Gas, Hybrid/PHEV). We auto-generate a starter list on first open; add custom items any time.",
    "Every vehicle now surfaces a Maintenance accordion inside Vehicle Settings — see Overdue / Due Soon / Upcoming at a glance, plus the single most-urgent 'Next Due' service.",
    "Log completed services with date, odometer, cost, notes, and an optional receipt photo — resets the countdown and builds a service history you can expand per item.",
    "Trip and Energy deletes now use in-app confirmations so they work reliably inside the preview (native browser confirms are blocked in iframes).",
    "Under the hood: safer deep-link filtering on the Maintenance page — opening it from a specific vehicle now filters instantly without stale results.",
  ],
};
